import styled from 'styled-components';

export const OnboardingCard = styled.div`
  grid-area: card;
`;
